import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CcamService } from 'src/app/services/facturation/ccam/ccam.service';
import { Ccam } from 'src/app/utils/interfaces/new/ccam.interface';
import { Modificateur } from 'src/app/utils/interfaces/new/modificateur.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modificateur',
  templateUrl: './modificateur.fragment.html',
  styleUrls: [
    './modificateur.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class ModificateurFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public code: string;
  public id: string;
  public libelleCode: string;
  public codeInfos: Ccam;

  public formGroup: FormGroup;

  public priceRef: string;
  public calculatedPrice: string;

  public codeAssoList = [{ id: 0, libelle: '0 - Aucun' }, { id: 1, libelle: '1 - Acte de tarif le plus élevé' }, { id: 2, libelle: '2 - Acte associé facturé à 50% de sa valeur' }, { id: 3, libelle: '3 - Acte associé facturé à 75% de sa valeur' }, { id: 4, libelle: '4 - Acte spécifique facturé à 100% de sa valeur' }];
  public modificateurList = [];

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModificateurModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _ccamService: CcamService,
  ) { }

  async ngOnInit(): Promise<void> {
    await this.getinfosCode();

    this.formGroup = this._formBuilder.group({
      m1: [''],
      m2: [{ value: '', disabled: true }],
      m3: [{ value: '', disabled: true }],
      m4: [{ value: '', disabled: true }],
      codeAsso: [''],
      tarifCalc: [this.calculatedPrice]
    });
  }

  public async getinfosCode() {
    this.codeInfos = await this._ccamService.findOneUser(this.id);
    this.libelleCode = this.codeInfos.libelle;
    this.priceRef = this.codeInfos.tarifSecteur;
    this.calculatedPrice = this.codeInfos.tarifSecteur;
    this.modificateurList = this.codeInfos.modificateurs.map((modificateur: Modificateur) => {
      return {
        id: modificateur.id,
        libelle: `${modificateur.libelle} (+${modificateur.tarif}${modificateur.devise})`
      }
    });
  }

  public onChangedAsso(event: any) {
    if (event === 3) {
      this.calculatedPrice = (parseFloat(this.calculatedPrice) / 2).toFixed(2).toString();
      this.formGroup.controls['tarifCalc'].setValue(this.calculatedPrice);
    } else if (event === 4) {
      this.calculatedPrice = (parseFloat(this.calculatedPrice) * 75 / 100).toFixed(2).toString();
      this.formGroup.controls['tarifCalc'].setValue(this.calculatedPrice);
    }
  }

  public onChanged(id: string, modificateurNumber: string) {
    if (modificateurNumber === 'm1') {
      this.updateTotalPrice(id, modificateurNumber, 'm2');
    } else if (modificateurNumber === 'm2') {
      this.updateTotalPrice(id, modificateurNumber, 'm3');
    } else if (modificateurNumber === 'm3') {
      this.updateTotalPrice(id, modificateurNumber, 'm4');
    } else {
      this.updateTotalPrice(id, modificateurNumber)
    }
  }

  private updateTotalPrice(id: string, modificateurNumber: string, enableModificateur?: string) {
    if (enableModificateur) {
      this.formGroup.controls[enableModificateur].enable();
    }
    const modificateur = this.codeInfos.modificateurs.find(x => x.id === id);
    this.calculatedPrice = this.calculTotalPrice(modificateur, modificateurNumber).toFixed(2).toString();
    this.formGroup.controls['tarifCalc'].setValue(this.calculatedPrice);
  }

  private calculTotalPrice(infosModificateur: any, modificateurNumber: string) {
    if (modificateurNumber === 'm1') {
      if (infosModificateur.devise === 'euros') {
        return parseFloat(this.priceRef) + parseFloat(infosModificateur.tarif);
      } else {
        const result = (parseFloat(this.priceRef) * parseFloat(infosModificateur.tarif) / 100);
        return parseFloat(this.priceRef) + result;
      }
    } else {
      if (infosModificateur.devise === 'euros') {
        return parseFloat(this.calculatedPrice) + parseFloat(infosModificateur.tarif);
      } else {
        const result = (parseFloat(this.calculatedPrice) * parseFloat(infosModificateur.tarif) / 100);
        return parseFloat(this.calculatedPrice) + result;
      }
    }
  }

  public onSubmit() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      const object = {
        id: this.id,
        m1: this.formGroup.get('m1').value,
        m2: this.formGroup.get('m2').value,
        m3: this.formGroup.get('m3').value,
        m4: this.formGroup.get('m4').value,
        codeAsso: this.formGroup.get('codeAsso').value,
        price: this.formGroup.get('tarifCalc').value
      }
      this.closeEmitter.emit(object);
    }
  }

  public closeModificateurModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit();
    }
  }
}
